import useTheme from "@mui/material/styles/useTheme";
import { observer } from "mobx-react-lite";
import React from "react";
import AvatarToggleIcon from "../icon/toolbar/AvatarToggleIcon";
import IconButton3D from "./IconButton3D";
import { useStore } from "csi/state/hooks";

const AvatarToggle = observer(() => {
	const { palette } = useTheme();	
	const secondary = palette.NavListItemSelectedBG;
	const rootStore = useStore();
	const { threeDStore: { canvasStore } } = rootStore;
	const { avatarData, toggleAvatarVisibility } = canvasStore;
	if (!avatarData) {
		return null;
	}
	const { visible } = avatarData;
    
	return (
		<IconButton3D
			fontSize={22}  
			onClick={toggleAvatarVisibility}
			res={visible ? "3DViewHideAvatar" : "3DViewShowAvatar"}
			sx={{
				backgroundColor : visible ? secondary : "transparent",
			}}            
		>
			<AvatarToggleIcon
				selected={visible}
			/>
		</IconButton3D>
	);
});

export default AvatarToggle;